import React from 'react';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { LINE_ITEM_INITIAL_PAYMENT } from '../../util/types';

import css from './ModificationCharges.css';

const { Money } = sdkTypes;

const ModificationCharges = ({ transaction, onOpenDetails, isTripExtension, isPriceDecreasedForModification, intl }) => {
  if (!transaction) return null;

  const initialPaymentLineItem = transaction.attributes.lineItems.find(
    item => item.code === LINE_ITEM_INITIAL_PAYMENT
  );
  
  // Fallback to protectedData.initialPayment if line item doesn't exist
  const initialPaymentFromProtectedData = transaction.attributes.protectedData?.initialPayment;
  
  console.log('initialPaymentLineItem', initialPaymentLineItem);
  console.log('isTripExtension', isTripExtension);
  console.log('isPriceDecreasedForModification', transaction);
  console.log('initialPaymentFromProtectedData', initialPaymentFromProtectedData);
  
  const payinTotal = transaction.attributes.payinTotal;

  const getTotalPrice = () => {
    if (isTripExtension) {
      return payinTotal.amount;
    }

    // Use line item amount if available, otherwise use protectedData
    const initialPaymentAmount = initialPaymentLineItem 
      ? Math.abs(initialPaymentLineItem.lineTotal.amount)
      : initialPaymentFromProtectedData 
      ? Math.abs(initialPaymentFromProtectedData)
      : 0;

    const modifiedAmount = payinTotal.amount - initialPaymentAmount;

    return isPriceDecreasedForModification
      ? Math.max(0, modifiedAmount)
      : modifiedAmount;
  };

  const totalPrice = getTotalPrice();

  const formattedTotalPrice = formatMoney(intl, new Money(totalPrice, payinTotal.currency), 2);

  return (
    <div className={css.modificationChargesRoot}>
      <span className={css.head}>{ isTripExtension ? 'Extension charges':'Modification charges'}</span>
      <div className={css.lineItemsContainer}>
        <span className={css.lineItemName}>Extra duration charges</span>
        <span className={css.lineItemValue}>{formattedTotalPrice}</span>
      </div>

      <div className={css.plus} onClick={onOpenDetails}>
        Show Details
      </div>
    </div>
  );
};

export default ModificationCharges;
